"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { THIRD_PARTY_PARAM } from "../_logic/constants";

/**
 * Agency-audience mode for comparison pages, read from `?3rdparty=true` and remembered for
 * the session so it survives navigation between comparisons.
 * @returns `isThirdParty`, a `withMode` href helper that keeps the param, and `toggle`
 */
export function useThirdParty() {
  // Hooks
  const router = useRouter();
  const searchParams = useSearchParams();

  // States
  const [isThirdParty, setIsThirdParty] = useState(false);

  // Handlers
  const withMode = (href: string) => (isThirdParty ? `${href}?${THIRD_PARTY_PARAM}=true` : href);

  const toggle = () => {
    const next = !isThirdParty;
    const url = new URL(window.location.href);
    if (next) {
      url.searchParams.set(THIRD_PARTY_PARAM, "true");
      sessionStorage.setItem(THIRD_PARTY_PARAM, "true");
    } else {
      url.searchParams.delete(THIRD_PARTY_PARAM);
      sessionStorage.removeItem(THIRD_PARTY_PARAM);
    }
    setIsThirdParty(next);
    router.push(url.pathname + url.search, { scroll: false });
  };

  // Effects
  useEffect(() => {
    const fromUrl = searchParams?.get(THIRD_PARTY_PARAM) === "true";
    if (fromUrl) sessionStorage.setItem(THIRD_PARTY_PARAM, "true");
    setIsThirdParty(fromUrl || sessionStorage.getItem(THIRD_PARTY_PARAM) === "true");
  }, [searchParams]);

  return { isThirdParty, withMode, toggle };
}
